import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import img1 from "../assets/New folder/New folder/Infra/BV4A0045.jpg";
import { FaGraduationCap, FaLightbulb, FaUsers, FaChartLine } from 'react-icons/fa';

const Difference = () => {
  const [activeAbility, setActiveAbility] = useState(null);

  const abilitiesData = [
    {
      icon: <FaGraduationCap />,
      title: "Academic Excellence",
      description: "Our holistic approach goes beyond traditional grading, focusing on comprehensive skill development and personal growth."
    },
    {
      icon: <FaLightbulb />,
      title: "Innovative Learning",
      description: "We foster critical thinking and creativity through our unique 8 Abilities framework, preparing students for real-world challenges."
    },
    {
      icon: <FaUsers />,
      title: "Collaborative Environment",
      description: "Our community-driven approach ensures personalized attention and a supportive learning ecosystem."
    },
    {
      icon: <FaChartLine />,
      title: "Continuous Growth",
      description: "We provide targeted feedback and growth strategies to help students continuously improve and excel."
    }
  ];

  return (
    <div className='w-full flex flex-col gap-5 font-opensans md:gap-[80px] md:flex-row justify-between md:items-center mt-5 mb-20  px-4 md:px-16'>
      <motion.div
        className=' mx-auto flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0 md:space-x-10'
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* Image Section - Mobile First */}
        <motion.div
          className='w-full md:w-1/2 rounded-2xl overflow-hidden shadow-2xl order-1 md:order-first'
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          <motion.img
            src={img1}
            alt="Maya Devi Campus"
            loading='lazy'
            decoding="async"
            className='w-full h-[300px] md:h-[500px] object-cover rounded-2xl transition-transform duration-300 hover:scale-110'
            initial={{ filter: 'blur(10px)', opacity: 0 }}
            animate={{ filter: 'blur(0px)', opacity: 1 }}
            transition={{ duration: 0.5 }}
            onLoad={(e) => {
              e.target.style.filter = 'none';
            }}
          />
        </motion.div>

        {/* Content Section - Responsive Layout */}
        <div className='w-full md:w-1/2 space-y-4 md:space-y-6'>
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <h2 className='text-[#0e4d38] font-bold text-2xl md:text-4xl uppercase mb-2 md:mb-4 text-center md:text-left'>
              Experience Excellence at the Best University in Dehradun – Maya Devi University
            </h2>
            <div className='w-[15%] h-1 bg-yellow-400 mb-4 mx-auto md:mx-0'></div>
          </motion.div>

          <p className='text-base md:text-xl text-gray-700 mb-6 leading-relaxed text-center md:text-left'>
            At Maya Devi University, recognized as the best university in Dehradun, we offer a transformative learning experience that goes beyond traditional education. Our innovative approach is built around the 8 Abilities – a comprehensive framework designed to develop well-rounded, future-ready individuals equipped with the skills to excel in their careers and make a lasting impact in the world.
          </p>

          {/* Abilities Grid - Responsive */}
          <div className='grid grid-cols-2 gap-3 md:gap-4'>
            {abilitiesData.map((ability, index) => (
              <motion.div
                key={index}
                className={`p-3 md:p-4 rounded-lg border transition-all duration-300 cursor-pointer text-center md:text-left
                  ${activeAbility === index
                    ? 'bg-yellow-100 border-yellow-400 shadow-lg'
                    : 'bg-white border-gray-200 hover:border-yellow-400'}`}
                onMouseEnter={() => setActiveAbility(index)}
                onMouseLeave={() => setActiveAbility(null)}
                whileHover={{ scale: 1.05 }}
              >
                <div className='flex flex-col md:flex-row items-center mb-2'>
                  <span className='text-2xl md:text-3xl text-yellow-500 mb-2 md:mb-0 md:mr-3'>{ability.icon}</span>
                  <h3 className='font-semibold text-sm md:text-lg'>{ability.title}</h3>
                </div>
                {activeAbility === index && (
                  <p className='text-xs md:text-sm text-gray-600 mt-2'>{ability.description}</p>
                )}
              </motion.div>
            ))}
          </div>

          {/* Call to Action - Centered on Mobile */}
          <motion.div
            className='mt-6 md:mt-8 flex justify-center md:block'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <Link to="/about-us/mdef">
              <button
                className='bg-yellow-400 text-black px-6 md:px-8 py-2 md:py-3 rounded-full font-semibold 
                uppercase tracking-wider transition-all duration-300 
                hover:bg-[#fa6f00] hover:text-white hover:shadow-xl text-sm md:text-base'
                onClick={() => window.scrollTo(0, 0)}
              >
                Explore Our Abilities
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  )
}

export default Difference